module.exports = __webpack_public_path__ + "media/state-press-3_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-3_2000.jpg
// module id = 45
// module chunks = 0